import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { PhasrRecommendationSideMenuBaseDataProvider } from './PhasrRecommendationSideMenuBaseDataProvider';

export class PhasrRecommendationSideMenuDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PhasrRecommendationSideMenuBaseDataProvider);
  }
}
